module.exports = __webpack_public_path__ + "static/img/icon_dropdown_down_20_normal.43d4185.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_dropdown_down_20_normal.svg
// module id = PtnL
// module chunks = 10